import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  
  constructor() { }
  // Set item in localStorage
  setItem(key: string, value: any): void {
    if (typeof value === 'string') {
      localStorage.setItem(key, value);
    } else {
      localStorage.setItem(key, JSON.stringify(value));
    }
  }

  // Get item from localStorage
  getItem<T>(key: string): T | null {
    const storedItem = localStorage.getItem(key);
    if (storedItem) {
      try {
        return JSON.parse(storedItem) as T;
      } catch {
        // Return the stored item as-is if it's not valid JSON
        return storedItem as any as T;
      }
    }
    return null;
  }

  // Remove item from localStorage
  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  // Clear all items from localStorage
  clear(): void {
    localStorage.clear();
  }
}
